<div class="page-header">
    <div class="row border-bottom pb-1 mb-2 align-items-center">
        <div class="col-md-4" [ngStyle]="!team.isActive && {'opacity':'0.4'}">
            <h3>{{team.name}}</h3>
        </div>
        <div class="col-md-4">
            <h4>Active people: {{team.activeUsersCount}} / {{team.totalUsersCount}}</h4>
        </div>
        <div class="col-md-4">
            <p>ID: {{team.id}} <button class="btn btn-" (click)="copyDBQuery(team.id)"><i class="fa-solid fa-copy"></i></button></p>
        </div>
    </div>
    <div class="row border-bottom mb-2">
        <div class="col-md-3">
            Company: {{team.company.name}} - {{team.company.domainNames}}
        </div>
        <div class="col-md-3">
            Created: {{team.created}}<br>
            <i class="far fa-clock"></i>
            {{team.notificationTime.timeZone}}
            {{team.notificationTime.hour}}:{{team.notificationTime.minute}}
        </div>
        <div class="col-md-2">
            <ul class="list-unstyled">
                <li>
                    <a [routerLink]="['/home', team.id]">
                        <i class="far fa-timeline"></i> Timeline
                    </a>
                </li>
                <li>
                    <a [routerLink]="['/calendar', team.id]">
                        <i class="far fa-calendar"></i> Calendar
                    </a>
                </li>
            </ul>
        </div>
        <div class="col-md-2">
            <ul class="list-unstyled">
                <li>
                    <a [routerLink]="['/setup/team', team.id]">
                        <i class="far fa-cog"></i> Team settings
                    </a>
                </li>
                <li>
                    <a [routerLink]="['/setup/teammembers', team.id]">
                        <i class="far fa-users"></i> Team members
                    </a>
                </li>
            </ul>
        </div>
    </div>
    <form class="row border-bottom row-cols-lg-auto g-3 align-items-center" [formGroup]="contactForm"  (submit)="updateContact(team.id)">
        <label for="contact" class="col-sm-1 col-form-label col-form-label-sm">Contact</label>
        <div class="col-sm-6">
            <input type="text" class="form-control form-control-sm" id="contact"  [formControl]="contactCtrl">
        </div>
        <div class="col-sm-3">
            <button type="submit" class="btn btn-primary btn-sm">Update</button>
        </div>
    </form>
    <div class="row">
        <div class="col-md-6">
            <h6 class="mb-1">Org units</h6>
            @if (team.organization) {
                <p>
                    Main org: <a [routerLink]="['/admin/organization', team.organization.id]">{{team.organization.name}}</a>
                </p>
                <br>
            }
            <table class="table table-condensed">
                <tbody>
                    @for (orgUnit of team.organisationalUnits; track orgUnit) {
                    <tr>
                        <td>{{orgUnit.id}}</td>
                        <td>{{orgUnit.type}}</td>
                        <td><a [routerLink]="['/admin/organization', orgUnit.id]">{{orgUnit.name}}</a></td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
        <div class="col-md-6">
            <h6 class="mb-0">Features enabled</h6>
            <table class="table table-condensed">
                <tbody>
                    @for (feature of features; track feature) {
                        <tr>
                            <td>
                                <span>{{feature}}</span>
                            </td>
                            <td>
                                <tm-slide-toggle [ngModel]="getFeatureToggleValue(team, feature)" (ngModelChange)="toggleFeature(team.id, feature)"></tm-slide-toggle>
                            </td>
                        </tr>
                    }                    
                </tbody>
            </table>
        </div>
    </div>
    <hr>
    <div class="row">
        <div class="col-md-6">
            <small>
                <ul class="nav nav-pills pe-5">
                    <li [ngClass]="{active: team.subscription.subscriptionType==='free'}" role="presentation">
                        <a href="">Free</a>
                    </li>
                    <li [ngClass]="{active: team.subscription.subscriptionType==='trial'}" role="presentation">
                        <a href="javascript:void(0)" (click)="switchToTrial(team.id)">Trial
                            @if(team.subscription.subscriptionType === 'trial'){
                            <br>{{team.subscription.end | days_from_now}} days remaining<br>
                            End: {{team.subscription.end | date: 'dd/MM/yyyy'}}
                            }
                        </a>
                        <button class="btn btn-sm btn-default" (click)="pushOutreachToCrm(team.id)" [hidden]="!(team.subscription.subscriptionType === 'trial')">Send to CRM for (outreach)                      </button>
                    </li>
                    <li [ngClass]="{active: team.subscription.subscriptionType==='one_dollar'}" role="presentation">
                        <a href="javascript:void(0)">OneDollar</a>
                    </li>
                    <li [ngClass]="{active: team.subscription.subscriptionType==='one_euro'}" role="presentation">
                        <a href="javascript:void(0)">OneEuro</a>
                    </li>
                    <li [ngClass]="{active: team.subscription.subscriptionType==='monthly'}" role="presentation">
                        <a href="javascript:void(0)">Monthly<br>{{team.subscription.unitPrice}}
                            {{team.subscription.currency | uppercase}}</a>
                    </li>
                    <li [ngClass]="{active: team.subscription.subscriptionType==='yearly'}" role="presentation">
                        <a [routerLink]="['/admin/set_yearly_subscription', team.id]" >
                            Yearly
                            @if(team.subscription.subscriptionType === 'yearly'){
                                <br>Creation: {{team.subscription.created | date: 'dd/MM/yyyy'}}
                                <br>Start: {{team.subscription.start | date: 'dd/MM/yyyy'}}
                                <br>End: {{team.subscription.end | date: 'dd/MM/yyyy'}}<br>Capacity: {{team.subscription.capacity}}
                            }
                        </a>
                        <button class="btn btn-sm btn-default" (click)="pushRenewalToCrm(team.id)" [hidden]="!(team.subscription.subscriptionType === 'yearly')">Send to CRM for (renewal)</button>
                    </li>
                </ul>
            </small>
        </div>
        <div class="col-md-6">
            <button class="btn btn-sm btn-primary me-1" (click)="disable(team.id)" [disabled]="!team.isActive">
                Disable
            </button>
            <button class="btn btn-sm btn-primary me-1" (click)="extendsTrialPeriod(team.id, 'week')">+Week
            </button>
            <button class="btn btn-sm btn-primary me-1" (click)="extendsTrialPeriod(team.id, 'month')">+Month
            </button>
            <button class="btn btn-sm btn-danger me-1" (click)="delete(team.id)" [disabled]="team.isActive">
                Delete
            </button>
            <a class="btn btn-sm btn-default me-1" href="https://teammood.quadernoapp.com/contacts/{{team.subscription.quadernoId}}" [hidden]="!team.subscription.quadernoId" target="_blank"><i class="fal fa-receipt"></i> Quaderno</a>
            <a class="btn btn-sm btn-default me-1" href="https://dashboard.stripe.com/customers/{{team.subscription.customerId}}" target="_blank" [hidden]="!team.subscription.customerId"><i class="fal fa-money-bill-alt"></i> Billing</a>
            <p class="alert alert-success" [hidden]="!delete_ok">{{delete_ok}}</p>
            <p class="alert alert-danger" [hidden]="!delete_errors">{{delete_errors}}</p>
        </div>
    </div>
</div>